import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SearchBarComponent } from "./search-bar.component";
import { SearchFilterComponent } from "./search-filter/search-filter.component";
import { SearchInputComponent } from "./search-input/search-input.component";

@NgModule({
  declarations: [SearchFilterComponent, SearchInputComponent, SearchBarComponent],
  imports: [CoreModule],
  exports: [SearchFilterComponent, SearchInputComponent, SearchBarComponent],
})
export class SearchBarModule {}
